<template>
  <div>
    <el-input size="mini" v-model="tag.tag_name" @change="editTag(tag.id, tag.tag_name)" @blur="closeEditTag()" :id="tag.id" style="width:300px"></el-input>
  </div>
</template>

<script>
export default {
  name: "tagDrawerInput",
  props: {
    tag: { type: Object },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    editTag(tag_id, tag_name) {
      this.$emit("editTag", tag_id, tag_name);
    },
    closeEditTag() {
      this.$emit("closeEditTag");
    },
  },
  watch: {},
};
</script>
